<template>
  <b-card>
    <div class="position-absolute" style="top: 10px; right: 15px; z-index:1;">
      <div class="ml-auto">
        <i
          @click="$emit('edit', availability)"
          class="fas fa-edit text-success hover-pointer"
          style="font-size: 14px"
        ></i>
        <i
          @click="
            $emit('delete', {
              availability: availability,
              fromDetailCard: true
            })
          "
          class="fas fa-trash-alt text-danger hover-pointer"
          style="font-size: 14px"
        ></i>
      </div>
    </div>
    <b-row v-if="availabilityData.services.length > 0" class="mt-1">
      <b-col style="font-size: 14px">
        <i class="fas fa-stethoscope"></i>
        Service(s)

        <div
          class="d-flex flex-column"
          v-for="(service, index) in availabilityData.services.slice(0, 3)"
          :key="index"
        >
          <span style="font-size: 12px" class="mb-0">{{ service }}</span>
        </div>
        <div
          v-if="availabilityData.services.length > 3"
          class="d-flex flex-column"
        >
          <span style="font-size: 12px" class="mb-0"
            >{{ availabilityData.services.length - 3 }} More...</span
          >
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col md="auto" style="font-size: 14px">
        <i class="b-fa b-fa-clock"></i> Time
        <div>
          <span style="font-size: 12px" class="mb-0">
            From {{ availabilityData.startDateTime }} to
            {{ availabilityData.endDateTime }}
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col style="font-size: 14px">
        <i class="fas fa-calendar"></i> Date
        <div v-if="!availabilityData.recurrence">
          <span style="font-size: 12px" class="mb-0">{{
            availabilityData.startDate
          }}</span>
        </div>
        <div v-else>
          <span style="font-size: 12px" class="mb-0"
            >Start: {{ availabilityData.startDate }}</span
          >
          <span style="font-size: 12px" class="mb-0">{{
            recurrenceDetails
          }}</span>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="availabilityData.placesOfService.length > 0" class="mt-1">
      <b-col style="font-size: 14px">
        <i class="fas fa-map-marker-alt"></i>
        Places of service

        <div
          class="d-flex flex-column"
          v-for="(placeOfService,
          index) in availabilityData.placesOfService.slice(0, 3)"
          :key="index"
        >
          <span style="font-size: 12px" class="mb-0">{{ placeOfService }}</span>
        </div>
        <div
          v-if="availabilityData.placesOfService.length > 3"
          class="d-flex flex-column"
        >
          <span style="font-size: 12px" class="mb-0"
            >{{ availabilityData.placesOfService.length - 3 }} More...</span
          >
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { formatTimeOnly, formatDateOnly } from "../../helpers/date";
export default {
  name: "ProviderCard",
  props: ["availability"],
  computed: {
    availabilityData() {
      return {
        id: this.availability.id,
        providerName: this.availability.provider?.fullName,
        services: this.availability.services.map(
          service =>
            (service.billingCodes.length > 0
              ? service.billingCodes[0].cptCode + ` - `
              : "") + service.name
        ),
        startDateTime: formatTimeOnly(this.availability.startDateTime),
        endDateTime: formatTimeOnly(this.availability.endDateTime),
        startDate: formatDateOnly(this.availability.startDateTime),
        endDate: formatDateOnly(this.availability.endDateTime),
        recurrence: this.availability.recurrence,
        placesOfService: this.availability.placesOfService.map(
          placeOfService => placeOfService.name
        )
      };
    },
    recurrenceDetails() {
      const recurrence = this.availability.recurrence;
      const repeat = recurrence.frequencyNumber;
      const unit = recurrence.frequencyUnit.toLowerCase();
      const endType = recurrence.endType;
      const selectedDays = [];
      let endText = "";

      for (const day in recurrence) {
        if (recurrence[day] === true) {
          selectedDays.push(day);
        }
      }

      if (endType === "ByOccurrences") {
        endText = `, ends after ${recurrence.occurrences} ocurrences`;
      } else if (endType === "ByDate") {
        endText = `,recurrency ends on ${this.formatDateOnly(
          recurrence.endDate
        )}`;
      }

      let daysText = "";
      if (selectedDays.length > 0) {
        daysText = `, on ${selectedDays.join(", ")}`;
      }

      return `Repeat every ${repeat} ${unit}${daysText}${endText}`;
    }
  }
};
</script>

<style>
.card-body {
  padding: 10px !important;
}
</style>
